<script lang="ts" setup>
import { ElConfigProvider } from 'element-plus'
import { useRoute } from 'vue-router';
import { createKey } from './utils';
import { useLocale } from '@/locales/useLocale';
import { initSocket, reconnectGame } from './service/socket';
import { onLogin, onLogout } from '@/hooks/core/useAuth';
import { navigateTo } from '@/utils/page';
import { PageEnum } from '@/enums/pageEnum';
import { useBenefitsStore } from '@/store/modules/benefits';
import { nextTick } from 'vue';

const route = useRoute();
const key = createKey(route.path);
const { getVueLocale } = useLocale();

nextTick(() => {
    onLogin((state) => {
        initSocket(state.token);
        reconnectGame();
        useBenefitsStore().updateBenefitsList();
    });
    onLogout(() => {
        navigateTo({
            name: PageEnum.HOME,
        });
    });
});
</script>
<template>
    <el-config-provider :locale="getVueLocale">
        <RouterView :key="key"/>
    </el-config-provider>
</template>